/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.15.0
 * @since 1.15.0
 */

import { LOCATION_CHANGE } from 'connected-react-router';
import produce from 'immer';
import { Reducer } from 'redux';

import {
    initialOnboardingState,
    ONBOARDING_DISABLE,
    ONBOARDING_DISABLE_ALL,
    ONBOARDING_ENABLE,
    ONBOARDING_FINISH,
    ONBOARDING_INIT_START,
    ONBOARDING_INIT_SUCCESS,
    ONBOARDING_NEXT_STEP,
    ONBOARDING_PAGE_READY_FOR_START,
    ONBOARDING_SET_CURRENT_STEP,
    ONBOARDING_SHOW_LATER,
    ONBOARDING_SKIP,
    ONBOARDING_START,
} from './onboardingConstants';
import { TOnboardingActions } from './types/onboardingActionTypes';
import {
    EOnboardingComponentsId,
    EOnboardingModalId,
    EOnboardingPage,
    EOnboardingStatus,
} from './types/onboardingTypes';

export type IOnboardingReducer = {
    currentStep?: EOnboardingComponentsId;
    isDisplayedByUser: boolean;
    isOnboardingExists: boolean;
    isWelcomeOnboardingCompleted: boolean;
    modalFinalId?: EOnboardingModalId;
    modalStartId?: EOnboardingModalId;
    page: EOnboardingPage;
    status: EOnboardingStatus;
    stepsIds: EOnboardingComponentsId[];
}

const onboardingReducer: Reducer<IOnboardingReducer, TOnboardingActions> =
    (state: IOnboardingReducer = initialOnboardingState, action: TOnboardingActions) =>
        produce(state, (draft) => {
            switch (action.type) {
                case ONBOARDING_INIT_START:
                    Object.assign(draft, initialOnboardingState);
                    draft.page = action.payload.page;
                    break;
                case ONBOARDING_INIT_SUCCESS:
                    draft.modalFinalId = action.payload.modalFinalId;
                    draft.modalStartId = action.payload.modalStartId;
                    draft.stepsIds = action.payload.stepsIds;
                    draft.isDisplayedByUser = action.payload.isDisplayedByUser;
                    draft.isOnboardingExists = action.payload.isOnboardingExists;
                    draft.isWelcomeOnboardingCompleted = action.payload.isWelcomeOnboardingCompleted;
                    break;

                case ONBOARDING_PAGE_READY_FOR_START:
                    draft.status = EOnboardingStatus.pageReady;
                    break;

                case ONBOARDING_START:
                    draft.status = EOnboardingStatus.start;
                    break;

                case ONBOARDING_ENABLE:
                    draft.isWelcomeOnboardingCompleted = false;
                    break;
                case ONBOARDING_DISABLE:
                case ONBOARDING_DISABLE_ALL:
                    draft.isWelcomeOnboardingCompleted = true;
                    draft.status = EOnboardingStatus.finish;
                    break;

                case ONBOARDING_SKIP:
                case ONBOARDING_FINISH:
                    draft.isWelcomeOnboardingCompleted = true;
                    draft.status = EOnboardingStatus.finish;
                    break;

                case ONBOARDING_NEXT_STEP:
                    draft.currentStep = action.payload.id;
                    break;

                case ONBOARDING_SET_CURRENT_STEP:
                    draft.currentStep = action.payload.id;
                    break

                case ONBOARDING_SHOW_LATER:
                    draft.status = EOnboardingStatus.finish;
                    draft.isWelcomeOnboardingCompleted = true;
                    break;

                case LOCATION_CHANGE:
                    Object.assign(draft, initialOnboardingState);
                    break;
            }
        });

export default onboardingReducer;
